import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { CronFlavor, CronOptions } from '@zapinfo/ngx-cron-editor';
import { ValidationHandler } from 'app/helpers/validation.handler';
import { Report } from 'app/models/report';
import { Team } from 'app/models/team';
import { User } from 'app/models/user';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';
import { ReportService } from 'app/services/report.service';
import { TeamService } from 'app/services/team.service';
import { UserService } from 'app/services/user.service';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { finalize } from 'rxjs/operators';
import * as _ from "lodash";

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {

  reportNamesFilter: string[] = [];
  
  tableLimitSelect = [5, 10, 20, 30, 50, 100];
  selectedTableLimit = 5;
  tableLoadingIndicator: boolean = true;

  reports: Report[] = [];
  unfilteredReports: Report[] = [];

  isNgSelectLoading: boolean = false;
  isDeleting: boolean = false;

  reportToDelete: Report = null;
  
  filterUsers: User[] = [];
  filterTeams: Team[] = [];
  
  @ViewChild(DatatableComponent, { static: true }) table: DatatableComponent;
  @ViewChild('deleteConfirmationModal') deleteConfirmationModal: ModalDirective;

  constructor(private ecoDocsTitleService: EcoDocsTitleService, public teamService: TeamService,
    private activatedRoute: ActivatedRoute, private reportService: ReportService,
    private validationHandler: ValidationHandler, public userService: UserService) { }


    ngOnInit(): void {
      this.ecoDocsTitleService.setTitle( 'Manage Reports', false );
      
      this.refreshReports();
    }

  private refreshReports() {
    this.tableLoadingIndicator = true;
    this.reportService.getAll().subscribe((r) => {
      this.reports = r;
      this.unfilteredReports = r;
      this.updateFilter();
      this.tableLoadingIndicator = false;
    });
  }

    innerWidth() {
      return window.innerWidth;
    }
  
    deleteReport() {
      this.isDeleting = true;
      this.reportService.delete(this.reportToDelete.id).pipe(finalize(() => {
        this.isDeleting = false;
        this.deleteConfirmationModal.hide();
        this.refreshReports();
      })).subscribe();
    }

    updateFilter() {
      // filter our data
      const temp = this.unfilteredReports.filter((report: Report) => {
  
        return (this.reportNamesFilter.length == 0 || this.reportNamesFilter.indexOf(report.name) != -1) &&
                (this.filterUsers.length == 0 || _.intersectionWith(this.filterUsers, (report.to_scope && report.to_scope.users)? report.to_scope.users: [], (a, b)=>{return a.id == b.id}).length > 0) &&
                (this.filterTeams.length == 0 || _.intersectionWith(this.filterTeams, (report.to_scope && report.to_scope.teams)? report.to_scope.teams: [], (a, b)=>{return a.id == b.id}).length > 0);
      });
  
      // update the rows
      this.reports = temp;
  
      // Whenever the filter changes, always go back to the first page
      this.table.offset = 0;
    }
}
